import { useCallback, useEffect, useState } from "react";
import { getVehicleRequest } from "../network";

export const useGetVehicle = (id) => {
  const [vehicleData, setVehicleData] = useState({
    engine_layout: "",
    insurance_deposit: "",
    text_label: "",
    main_image: "",
    power: "",
    racing: "",
    sits_number: "",
    title: "",
    vehicle_mark_id: "",
    vehicle_type_id: "",
    video: "",
    volume: "",
    color_id: "",
  });

  const getVehicle = useCallback(async () => {
    const res = await getVehicleRequest(id);
    setVehicleData(res.data);
    return res.data;
  }, []);

  useEffect(() => {
    getVehicle();
  }, []);

  return { vehicleData };
};
